/** @jsx jsx */
import { Component } from 'react'
import { default_theme as theme } from '../../emotion/theme'
import { connect } from 'react-redux'
import { size } from 'lodash'
import { jsx, css } from '@emotion/core'
import Pluralize from 'react-pluralize'
import { CourseCardOverlay } from './CourseCardOverlay'
import BlueButton from '../layout/BlueButton'
import { CourseBannerContainer } from './CourseBannerContainer'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Separator } from '../layout/Separator'
import rocket_img from '../../images/start_assessment.png'
import BusyMask from '../BusyMask'

class AssessmentIntro extends Component {

    componentDidMount() {
        window.scroll(0, 0)        
    }
    
    onContinue = () => {
        const { onContinue, assessment } = this.props
        onContinue(assessment)
    }
    
    render() {
        const { course_section, course } = this.props
        
        if ( ! course.banner_image.original_download_url ) {
            return <BusyMask loading={true} />
        }
        
        return (
            <CourseBannerContainer>
              <div css={ [course_banner_image_container, css`{background-image: url(${course.banner_image.original_download_url})}`] }>
                &nbsp;
              </div>
              <CourseCardOverlay>
                <div css={rocket_icon_style}>
                  <img css={rocket_icon_img_style} src={rocket_img} />
                </div>
                <div css={banner_header_style}>
                  START ASSESSMENT
                </div>

                <Separator variant="h30" />
                
                <div css={banner_blurb_style}>
                  {`${course && course.course_type === "course" ? "You will need to pass this assessment in order to proceed with and pass this course." : "You will need to complete this assessment in order to proceed with this survey."} Select START ASSESSMENT to continue.`}
                </div>

                <Separator variant="h30" />
                
                <div css={banner_info_style}>
                  <div css={info_detail_item_style}>
                    <div css={icon_style}>
                      <FontAwesomeIcon css={info_icon} icon={faQuestionCircle} />
                    </div>
                    <Pluralize singular="question" count={size(course_section.questions)} />
                  </div>
                </div>

                <Separator variant="h40" />
                
                <div>
                  <BlueButton onClick={this.onContinue} css={start_learning_button} >
                    START ASSESSMENT
                  </BlueButton>
                </div>
              </CourseCardOverlay>
            </CourseBannerContainer>
        )
    }
    
}

function mapStateToProps(state, props) {
    return {}
}
    

export default connect(mapStateToProps)(AssessmentIntro)


const course_banner_image_container = css`
filter: blur(8px);
-webkit-filter: blur(8px);
position: absolute;
top: 0px;
left: 0px;
width: 100%;
height: 100%;
object-fit: cover;
object-position: 0 0;
`

const rocket_icon_style = css`
font-size: 15px;
`

const rocket_icon_img_style = css`
height: 70px;
`

const banner_header_style = css`
font-size: 28px;
`

const banner_blurb_style = css`
text-align: center;
`

const banner_info_style = css`
display: flex;
justify-content: center;
`

const icon_style = css`
width: 15px;
margin-right: 5px;
display: flex;
justify-content: center;
`

const info_icon = css`
margin-right: 5px;
`

const info_detail_item_style = css`
display: flex;
align-items: center;
`

const start_learning_button = css`
font-size: 20px;
padding-left: 24px;
padding-right: 24px;
height: 50px;
&:hover {
}
`
